import React, { useEffect, useState }   from "react";
import {Link}                           from "react-router-dom";

import "./products.scss"

import {OmniSearchCarousel} from "../../omni-search-carousel/omni-search-carousel";
import {Shimmer}            from "../../common/shimmer/shimmer";
import {scrollToTop}        from "@Xpresso/routes/omni-search/omni-search-layout/common/common.js";
import {ROUTE_OMNISEARCH}   from "@Xpresso/routes/omni-search/omni-search-route";

const WIDTH_COMPONENT = 193
const EDGE_ITEM_DIVISOR = 4
const KEY_PRODUCT = 'p'
const KEY_PRODUCT_FILTER = 'filter_products'

export const Products = ({addSearchHistoryRecord, products, queryParam, queryTemplatePairs}) => {
    if(!Array.isArray(products)) {
        return null
    }

    if(products.length < 1) {
        return null
    }

    return (
        <div className="products-pdct0923">
            <div className="products">
                <p className="products-text">
                    Products
                </p>
            </div>
            {
                <OmniSearchCarousel
                    Component={Product}
                    items={products}
                    widthComponent={WIDTH_COMPONENT}
                    edgeItemVisibilityDivisor={EDGE_ITEM_DIVISOR}
                    additionalProps={{addSearchHistoryRecord, queryParam, queryTemplatePairs}}
                />
            }
        </div>
    )
}

const Product = ({item, addSearchHistoryRecord, queryParam, queryTemplatePairs}) => {
    const [imageLoaded, setImageLoaded] = useState(false)
    const product = item

    const queryURI = `q=${encodeURIComponent(product.name?.toLowerCase())}`
    const productURI = `${KEY_PRODUCT}=${encodeURIComponent(product.name?.toLowerCase())}`
    const link = `${ROUTE_OMNISEARCH.PRODUCTS}?${queryURI}&${productURI}`

    return (
        <Link
            className="product-abc098"
            to={link}
            onClick={() => {
                addSearchHistoryRecord({
                    search_handler: "products",
                    suggestion_data: product.name, 
                    suggestion_name: product.name,
                    suggestion_type: "product",
                })               
              
                queryTemplatePairs(product)
                scrollToTop()
            }}
        >
            {!imageLoaded && <Shimmer name={"image-container"} />}
            {
                <div
                    className="image-container"
                    style={{display: imageLoaded ? 'flex' : 'none'}}
                >
                    <img
                        className="image"
                        src={product.logo}
                        alt={`image-${product.description}`}
                        onLoad={() => setImageLoaded(true)}
                    />
                </div>
            }
            <div className="product-name">
                <p>{product.name}</p>
            </div>
        </Link>
    )
}